
'use strict';

/*eslint-disable */


var PANORAMA = {}; //global namespace

PANORAMA.hasBrowserWebgl = function() {
    var canvas = document.createElement("canvas");
    var gl = canvas.getContext("webgl")
      || canvas.getContext("experimental-webgl");
    if (gl && gl instanceof WebGLRenderingContext)
      return true;
    else
      return false;
};

PANORAMA.PanoramaView = function( container, useCssRenderer ) {	
	
	//defaults
		
	var initalFadeInTimeout = 500; //see also .panorama-overlay transition in css
	var initalRotatingTimeout = 2000;	
	var maxRotationSpeed = .1;
	var rotationSpeedDelta = .001;
	var rotatingTimeout = 6000;
	var defaultFov = 75;
	var minFov = 30;
	var maxFov = 100;
	
	var target = new THREE.Vector3();
	var lon = 90, lat = 0;
	var phi = 0, theta = 0;
	var rotationSpeed = 0;
	var rotating = false;
	var touchX, touchY;
	
	var animationStatus = "initial";

	////////////////

	var renderer;
	var camera = new THREE.PerspectiveCamera( defaultFov, container[0].clientWidth  / container[0].clientHeight, 1, 1000);
	var scene = new THREE.Scene();

	//if (useCssRenderer === undefined)
	//	useCssRenderer = !PANORAMA.hasBrowserWebgl();
	useCssRenderer = false; // TODO: css is not tested currently
	
	var panoramaRenderer = useCssRenderer ? new CSSPanoramaRenderer() 
										: new WebGLPanoramaRenderer();

	renderer.setSize( container[0].clientWidth, container[0].clientHeight );
	container.append(renderer.domElement);	

	//loading...
	
	var overlay = angular.element("<div>")
		.addClass("panorama-overlay");		
    container.append(overlay);
	
	var progressbar = angular.element("<div>")
		.addClass("panorama-progressbar")
		.html("<img src='/assets/images/ipad_loading_100x100.gif'>");
    container.append(progressbar);
	
	//buttons, overlays
	
	var buttonFullscreen = angular.element("<div>")
		.addClass("panorama-button panorama-button-fullscreen")
		.html("<span class='glyphicon glyphicon glyphicon-fullscreen'></span>")
		.on("click touchstart",function() {
			container.addClass("panorama-fullscreen");
			onWindowResize();
		});									
	container.append(buttonFullscreen);

	var buttonRestore = angular.element("<div>")
		.addClass("panorama-button panorama-button-restore")
		.html("<span class='glyphicon glyphicon glyphicon-remove'></span>")
		.on("click touchstart",function() {
			container.removeClass("panorama-fullscreen");
			onWindowResize();
		});									
	container.append(buttonRestore);
	
	var logo = angular.element("<div>")
		.addClass("panorama-logo")
		.html("<a href='http://archlinexp.com'><img src='/assets/images/Arch_360_wiever_watermark_01.png'></a>");		
	container.append(logo);
	
	//event listeners
		
	container[0].addEventListener( 'mousedown', onDocumentMouseDown, false );
	container[0].addEventListener( 'wheel', onDocumentMouseWheel, false );

	container[0].addEventListener( 'touchstart', onDocumentTouchStart, false );
	container[0].addEventListener( 'touchmove', onDocumentTouchMove, false );

	window.addEventListener( 'resize', onWindowResize, false );
	
	// staring  animation
	animate();
	
	//changing images and direction
	this.set = function(panoramaDescriptor) {
		panoramaRenderer.set(panoramaDescriptor);	
	};
	
	//destroy
	this.dispose = function() {
		
		renderMode.dispose(); //differend dispose method for webgl and css renderes
		container[0].removeEventListener( 'mousedown', onDocumentMouseDown );
		container[0].removeEventListener( 'wheel', onDocumentMouseWheel );
		container[0].removeEventListener( 'touchstart', onDocumentTouchStart );
		container[0].removeEventListener( 'touchmove', onDocumentTouchMove );
		window.removeEventListener( 'resize', onWindowResize);
	};
	
	//WEBGL	

	function WebGLPanoramaRenderer() {
         
        var currentImageUrls = null;
         	
		this.set = function(panoramaDescriptor) {
					
			var imageUrls = panoramaDescriptor.images
			//Fading out existing images
			overlay.css("opacity", "1");
			animationStatus = "fadeOut";
			var fadeOutTime = currentImageUrls ? initalFadeInTimeout : 0;
			
			setTimeout(function() {

				//camera reset
				lon = panoramaDescriptor.direction;
				lat = 0;
				camera.fov = defaultFov;
				camera.updateProjectionMatrix();
					
				//old text to dispose
				var oldTexture = skyBoxShader.uniforms["tCube"].value;
				
				if (imageUrls) {
								
					animationStatus = "loading";
					progressbar.css("display", "block");
					overlay.css("opacity", "1");
					
	
					var loader = new THREE.CubeTextureLoader();
					var textureCube = loader.load(imageUrls, function(texture) {
		
						progressbar.css("display", "none");
						animationStatus = "fadeIn";
	
					}, function(xhr) {
						//console.log((xhr.loaded / xhr.total * 100) + '% loaded'); - this event handler is not implemented in three js currently
					}, function(xhr) {
		
						console.log('Cannort load textures');
		
						var errorIcon = angular.element("<div>").addClass("panorama-error").html("<img src='/assets/images/missing-image-100x100.png'>");
						container.append(errorIcon);
		
						progressbar.css("display", "none");
						animationStatus = "error";
		
					});
					
					
					skyBoxShader.uniforms["tCube"].value = textureCube;					
				}	
				else {
					
					animationStatus = "cleared";
					overlay.css("opacity", "1");				
					skyBoxShader.uniforms["tCube"].value = null;										
				}
				
				currentImageUrls = imageUrls;					
				if (oldTexture)
					oldTexture.dispose();
						
			}, fadeOutTime);

		}; 

        
		var skyBoxShader = THREE.ShaderLib["cube"];

		var skyBoxMaterial = new THREE.ShaderMaterial({
			fragmentShader : skyBoxShader.fragmentShader,
			vertexShader : skyBoxShader.vertexShader,
			uniforms : skyBoxShader.uniforms,
			depthWrite : false,
			side : THREE.BackSide
		});

		var cubeGeometry = new THREE.BoxGeometry(10, 10, 10);
		var cubeMesh = new THREE.Mesh(cubeGeometry, skyBoxMaterial);
		scene.add(cubeMesh);

		renderer = new THREE.WebGLRenderer(  {antialias:true} );
		renderer.autoClear = false;
		
		
        
    	this.dispose = function() {
			scene.remove( self.cubeMesh );

			// clean up
			cubeGeometry.dispose();
			skyBoxMaterial.dispose();
			textureCube.dispose();
		};

		return this;
	}

	/// CSS

	function CSSPanoramaRenderer() {

		var sides = [
			{
				position: [ -512, 0, 0 ],
				rotation: [ 0, Math.PI / 2, 0 ]
			},
			{
				position: [ 512, 0, 0 ],
				rotation: [ 0, -Math.PI / 2, 0 ]
			},
			{
				position: [ 0,  512, 0 ],
				rotation: [ Math.PI / 2, 0, Math.PI ]
			},
			{
				position: [ 0, -512, 0 ],
				rotation: [ - Math.PI / 2, 0, Math.PI ]
			},
			{
				position: [ 0, 0,  512 ],
				rotation: [ 0, Math.PI, 0 ]
			},
			{
				position: [ 0, 0, -512 ],
				rotation: [ 0, 0, 0 ]
			}
		];

		for ( var i = 0; i < sides.length; i ++ ) {

			var side = sides[ i ];

			var imageElement = document.createElement( 'img' );
			imageElement.width = 1026; // 2 pixels extra to close the gap.
			imageElement.src = imageUrls[i];

			var object = new THREE.CSS3DObject( imageElement );
			object.position.fromArray( side.position );
			object.rotation.fromArray( side.rotation );
			scene.add( object );

		}

		renderer = new THREE.CSS3DRenderer();
		
		renderer.setSize( container[0].clientWidth, container[0].clientHeight );
		container.append(renderer.domElement);	
		
		setTimeout(function() {
			rotating = true;
		}, initalRotatingTimeout);

		//making css version disposable
		return{
			dispose: function() {
				for( var i = scene.children.length - 1; i >= 0; i--) { 
					obj = scene.children[i];
     				scene.remove(obj);
				}	
			}
		};
	}

	function onWindowResize() {

		camera.aspect = container[0].clientWidth / container[0].clientHeight;
		camera.updateProjectionMatrix();
	
		renderer.setSize(container[0].clientWidth, container[0].clientHeight);
	
	};
	
	function onDocumentMouseDown(event) {
	
		event.preventDefault();
	
		document.addEventListener('mousemove', onDocumentMouseMove, false);
		document.addEventListener('mouseup', onDocumentMouseUp, false);
	
		stopRotating();
	
	};
	
	function onDocumentMouseMove(event) {
	
		var movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
		var movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
	
		lon -= movementX * 0.2;
		lat += movementY * 0.2;
	
	};
	
	function onDocumentMouseUp(event) {
	
		document.removeEventListener('mousemove', onDocumentMouseMove);
		document.removeEventListener('mouseup', onDocumentMouseUp);
	
		stopRotating();
	
	};
	
	function onDocumentMouseWheel(event) {
		if (event.deltaY) {
			event.preventDefault();
		
			camera.fov += event.deltaY > 0 ? 4 : -4;
			if (camera.fov < minFov)
				camera.fov = minFov;
			if (camera.fov > maxFov)
				camera.fov = maxFov;
			camera.updateProjectionMatrix();
		
			stopRotating();			
		}
	};
	
	function onDocumentTouchStart (event) {
	
		event.preventDefault();
	
		var touch = event.touches[0];
	
		touchX = touch.screenX;
		touchY = touch.screenY;
	
		stopRotating();
	};
	
	function onDocumentTouchMove (event) {
	
		event.preventDefault();
	
		var touch = event.touches[0];
	
		lon -= (touch.screenX - touchX ) * 0.1;
		lat += (touch.screenY - touchY ) * 0.1;
	
		touchX = touch.screenX;
		touchY = touch.screenY;
	};
	
	var rotationTimer;
	function stopRotating() {
	
		if (rotationTimer)
			clearTimeout(rotationTimer);
	
		rotating = false;
		rotationSpeed = 0;
	
		rotationTimer = setTimeout(function() {
			rotating = true;
		}, rotatingTimeout);
	}
	
	function animate() {
	
		requestAnimationFrame(animate);
	
		if (rotating) {
			rotationSpeed = Math.min(rotationSpeedDelta + rotationSpeed, maxRotationSpeed);
			lon += rotationSpeed;
		}
	
		lat = Math.max(-85, Math.min(85, lat));
		phi = THREE.Math.degToRad(90 - lat);
		theta = THREE.Math.degToRad(lon);
	
		target.x = Math.sin(phi) * Math.cos(theta);
		target.y = Math.cos(phi);
		target.z = Math.sin(phi) * Math.sin(theta);
	
		camera.lookAt(target);
	
		renderer.render(scene, camera);
		
		//staring fadeIn after the first render with the new textures are made to avoid blocking transition	
		if (animationStatus == "fadeIn") {
			
			overlay.css("opacity", "0"); 
			
			stopRotating();
			setTimeout(function() {
				rotating = true;
			}, initalFadeInTimeout + initalRotatingTimeout);
			
			animationStatus = "ready";			
		}
	

	}
	
	return this;
};

/*eslint-enable */
/*eslint-disable */

/**
 * Based on http://www.emagix.net/academic/mscs-project/item/camera-sync-with-css3-and-webgl-threejs
 * @author mrdoob / http://mrdoob.com/
 */

THREE.CSS3DObject = function ( element ) {

	THREE.Object3D.call( this );

	this.element = element;
	this.element.style.position = 'absolute';

	this.addEventListener( 'removed', function ( event ) {

		if ( this.element.parentNode !== null ) {

			this.element.parentNode.removeChild( this.element );

		}

	} );

};

THREE.CSS3DObject.prototype = Object.create( THREE.Object3D.prototype );
THREE.CSS3DObject.prototype.constructor = THREE.CSS3DObject;

THREE.CSS3DSprite = function ( element ) {

	THREE.CSS3DObject.call( this, element );

};

THREE.CSS3DSprite.prototype = Object.create( THREE.CSS3DObject.prototype );
THREE.CSS3DSprite.prototype.constructor = THREE.CSS3DSprite;

//

THREE.CSS3DRenderer = function () {

	console.log( 'THREE.CSS3DRenderer', THREE.REVISION );

	var _width, _height;
	var _widthHalf, _heightHalf;

	var matrix = new THREE.Matrix4();

	var cache = {
		camera: { fov: 0, style: '' },
		objects: {}
	};

	var domElement = document.createElement( 'div' );
	domElement.style.overflow = 'hidden';

	domElement.style.WebkitTransformStyle = 'preserve-3d';
	domElement.style.MozTransformStyle = 'preserve-3d';
	domElement.style.oTransformStyle = 'preserve-3d';
	domElement.style.transformStyle = 'preserve-3d';

	this.domElement = domElement;

	var cameraElement = document.createElement( 'div' );

	cameraElement.style.WebkitTransformStyle = 'preserve-3d';
	cameraElement.style.MozTransformStyle = 'preserve-3d';
	cameraElement.style.oTransformStyle = 'preserve-3d';
	cameraElement.style.transformStyle = 'preserve-3d';

	domElement.appendChild( cameraElement );

	this.setClearColor = function () {};

	this.getSize = function() {

		return {
			width: _width,
			height: _height
		};

	};

	this.setSize = function ( width, height ) {

		_width = width;
		_height = height;

		_widthHalf = _width / 2;
		_heightHalf = _height / 2;

		domElement.style.width = width + 'px';
		domElement.style.height = height + 'px';

		cameraElement.style.width = width + 'px';
		cameraElement.style.height = height + 'px';

	};

	var epsilon = function ( value ) {

		return Math.abs( value ) < Number.EPSILON ? 0 : value;

	};

	var getCameraCSSMatrix = function ( matrix ) {

		var elements = matrix.elements;

		return 'matrix3d(' +
			epsilon( elements[ 0 ] ) + ',' +
			epsilon( - elements[ 1 ] ) + ',' +
			epsilon( elements[ 2 ] ) + ',' +
			epsilon( elements[ 3 ] ) + ',' +
			epsilon( elements[ 4 ] ) + ',' +
			epsilon( - elements[ 5 ] ) + ',' +
			epsilon( elements[ 6 ] ) + ',' +
			epsilon( elements[ 7 ] ) + ',' +
			epsilon( elements[ 8 ] ) + ',' +
			epsilon( - elements[ 9 ] ) + ',' +
			epsilon( elements[ 10 ] ) + ',' +
			epsilon( elements[ 11 ] ) + ',' +
			epsilon( elements[ 12 ] ) + ',' +
			epsilon( - elements[ 13 ] ) + ',' +
			epsilon( elements[ 14 ] ) + ',' +
			epsilon( elements[ 15 ] ) +
		')';

	};

	var getObjectCSSMatrix = function ( matrix ) {

		var elements = matrix.elements;

		return 'translate3d(-50%,-50%,0) matrix3d(' +
			epsilon( elements[ 0 ] ) + ',' +
			epsilon( elements[ 1 ] ) + ',' +
			epsilon( elements[ 2 ] ) + ',' +
			epsilon( elements[ 3 ] ) + ',' +
			epsilon( - elements[ 4 ] ) + ',' +
			epsilon( - elements[ 5 ] ) + ',' +
			epsilon( - elements[ 6 ] ) + ',' +
			epsilon( - elements[ 7 ] ) + ',' +
			epsilon( elements[ 8 ] ) + ',' +
			epsilon( elements[ 9 ] ) + ',' +
			epsilon( elements[ 10 ] ) + ',' +
			epsilon( elements[ 11 ] ) + ',' +
			epsilon( elements[ 12 ] ) + ',' +
			epsilon( elements[ 13 ] ) + ',' +
			epsilon( elements[ 14 ] ) + ',' +
			epsilon( elements[ 15 ] ) +
		')';

	};

	var renderObject = function ( object, camera ) {

		if ( object instanceof THREE.CSS3DObject ) {

			var style;

			if ( object instanceof THREE.CSS3DSprite ) {

				// http://swiftcoder.wordpress.com/2008/11/25/constructing-a-billboard-matrix/

				matrix.copy( camera.matrixWorldInverse );
				matrix.transpose();
				matrix.copyPosition( object.matrixWorld );
				matrix.scale( object.scale );

				matrix.elements[ 3 ] = 0;
				matrix.elements[ 7 ] = 0;
				matrix.elements[ 11 ] = 0;
				matrix.elements[ 15 ] = 1;

				style = getObjectCSSMatrix( matrix );

			} else {

				style = getObjectCSSMatrix( object.matrixWorld );

			}

			var element = object.element;
			var cachedStyle = cache.objects[ object.id ];

			if ( cachedStyle === undefined || cachedStyle !== style ) {

				element.style.WebkitTransform = style;
				element.style.MozTransform = style;
				element.style.oTransform = style;
				element.style.transform = style;

				cache.objects[ object.id ] = style;

			}

			if ( element.parentNode !== cameraElement ) {

				cameraElement.appendChild( element );

			}

		}

		for ( var i = 0, l = object.children.length; i < l; i ++ ) {

			renderObject( object.children[ i ], camera );

		}

	};

	this.render = function ( scene, camera ) {

		var fov = 0.5 / Math.tan( THREE.Math.degToRad( camera.fov * 0.5 ) ) * _height;

		if ( cache.camera.fov !== fov ) {

			domElement.style.WebkitPerspective = fov + "px";
			domElement.style.MozPerspective = fov + "px";
			domElement.style.oPerspective = fov + "px";
			domElement.style.perspective = fov + "px";

			cache.camera.fov = fov;

		}

		scene.updateMatrixWorld();

		if ( camera.parent === null ) camera.updateMatrixWorld();

		camera.matrixWorldInverse.getInverse( camera.matrixWorld );

		var style = "translate3d(0,0," + fov + "px)" + getCameraCSSMatrix( camera.matrixWorldInverse ) +
			" translate3d(" + _widthHalf + "px," + _heightHalf + "px, 0)";

		if ( cache.camera.style !== style ) {

			cameraElement.style.WebkitTransform = style;
			cameraElement.style.MozTransform = style;
			cameraElement.style.oTransform = style;
			cameraElement.style.transform = style;

			cache.camera.style = style;

		}

		renderObject( scene, camera );

	};

};

/*eslint-enable */
(function() {
	'use strict';

	angular.module('panorama', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'xeditable', 'pascalprecht.translate', 'sn.addthis', 'panorama']);

})();

(function() {
	'use strict';

	angular.module('panorama').directive('thumbnail', thumbnail);

	/** @ngInject */
	function thumbnail( ) {
			
		var directive = {
			restrict : 'E',
			scope : {
				id : "@",
				descriptor : "="
			},
			templateUrl: 'app/components/thumbnail/thumbnail.html',
			link: function(scope) {
				
				//TODO select appropriate thumbnail image
				var thumbnailImage = scope.descriptor.images[4];			
				scope.imageUrl = "uploads/panorama/" + scope.id + "/thumb256/" + thumbnailImage;
				
			}
			
		};
		return directive;
	}

})();

(function() {
	'use strict';

	angular.module('panorama').directive('panorama', panorama);

	/** @ngInject */
	function panorama($log, $rootScope) {

		var directive = {
			restrict : 'E',
			/*scope : {
				
			},*/
			link : function(scope, element /*, attrs*/) {
				
				element.addClass("panorama-container");

				$log.log("create panorama");
				var panoramaViewer = null;
				/* global PANORAMA */
				panoramaViewer = new PANORAMA.PanoramaView(element);
				
				var descriprotImageWatch = $rootScope.$watch(function(scope) {
					return scope.panoramaDescriptor.images;
				}, function() {
					panoramaViewer.set($rootScope.panoramaDescriptor);
				});

				scope.$on('$destroy', function() {
					$log.log("destroy panorama");
					descriprotImageWatch(); //removes watch on rootscope
					if (panoramaViewer)
						panoramaViewer.dispose();
					else
						$log.log("destroy panorama error");
				});

			}
		};

		return directive;

	}

})();

(function() {
	'use strict';

	angular.module('panorama').directive('languageSwitch', languageSwitch);

	/** @ngInject */
	function languageSwitch($log, $translate) {
		
		var directive = {
			restrict : 'E',
			templateUrl: 'app/components/languageSwitch/languageSwitch.html',
			scope : {},
			link : function(scope) {
				scope.supportedLanguages = $translate.getAvailableLanguageKeys();
				scope.currentLanguage = $translate.proposedLanguage();
				scope.changeLanguage = function(lang) {
					$translate.use(lang);	
					scope.currentLanguage = lang;
				};
				$log.log($translate.use());
			}
		};
		return directive;
	}

})();

(function() {
	'use strict';

	angular.module('panorama').directive('account', account);

	/** @ngInject */
	function account($http, $log, $rootScope, $location) {
		
		var directive = {
			restrict : 'E',
			templateUrl: 'app/components/account/account.html',

			link : function(scope) {

				scope.$watch(function(scope) {
					return scope.facebook.status;
				}, function() {

					$log.log(scope);

					$rootScope.facebook.serial = null;

					if (scope.facebook && scope.facebook.status == "loggedIn") {
						$http.get("api/auth.php?facebookid=" + scope.facebook.clientid + "&mark=2").then(function(response) {
							if (response.data && response.data.serial) {
								$rootScope.facebook.serial = response.data.serial;
							} else
								$rootScope.facebook.serial = null;
								
						}, function( response) {
							$log.log(response);
							$rootScope.facebook.serial = null;
						});				
					}
						
					if ($rootScope.facebook.serial==null)
					{
						var str=$location.path();
						var res = str.split("/");
						var serial = res[2];

						if (angular.isDefined(serial))
						{
							$http.get("api/auth2.php?serial=" + serial ).then(function(response) {
								if (response.data && response.data.serial) {
									scope.serial = response.data.serial;
									scope.status ='loggedIn';
								}
							}, function( response) { $log.log(response); });
						}
					}
				});		
			}
		};
		return directive;
	}
})();

/*eslint-disable */

// This is called with the results from from FB.getLoginStatus().
function statusChangeCallback(response) {
	// The response object is returned with a status field that lets the
	// app know the current login status of the person.
	// Full docs on the response object can be found in the documentation
	// for FB.getLoginStatus().
	if (response.status === 'connected') {
		// Logged into your app and Facebook.
		FB.api('/me', function(response) {
	
			setFacebookScope ({
				name: response.name,
				clientid: response.id,
				status: "loggedIn"
			});
		});
	} else if (response.status === 'not_authorized') {
		// The person is logged into Facebook, but not your app.
		// document.getElementById('fb-status').innerHTML = 'Please log ' + 'into this app.';
		setFacebookScope ({
			status: "pleaseLoginToApp"
		});
	} else {
		// The person is not logged into Facebook, so we're not sure if
		// they are logged into this app or not.
		// document.getElementById('fb-status').innerHTML = 'Please log ' + 'into Facebook.';
		setFacebookScope ({
			status: "pleaseLoginToFacebook"
		});
	}
}

// This function is called when someone finishes with the Login
// Button.  See the onlogin handler attached to it in the sample
// code below.
function checkLoginState() {
	FB.getLoginStatus(function(response) {
		statusChangeCallback(response);
	});
}

window.fbAsyncInit = function() {
	FB.init({
		appId : '452463711617282',
		cookie : true, // enable cookies to allow the server to access
		// the session
		xfbml : true, // parse social plugins on this page
		version : 'v2.5' // use graph api version 2.5
	});

	// Now that we've initialized the JavaScript SDK, we call
	// FB.getLoginStatus().  This function gets the state of the
	// person visiting this page and can return one of three states to
	// the callback you provide.  They can be:
	//
	// 1. Logged into your app ('connected')
	// 2. Logged into Facebook, but not your app ('not_authorized')
	// 3. Not logged into Facebook and can't tell if they are logged into
	//    your app or not.
	//
	// These three cases are handled in the callback function.

	FB.getLoginStatus(function(response) {
		statusChangeCallback(response);
	});

};

// Load the SDK asynchronously
( function(d, s, id) {
		var js,
		    fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id))
			return;
		js = d.createElement(s);
		js.id = id;
		js.src = "//connect.facebook.net/en_US/sdk.js";
		fjs.parentNode.insertBefore(js, fjs);
	}(document, 'script', 'facebook-jssdk'));



function setFacebookScope( desc ) {
	var scope = angular.element( document.getElementsByTagName('body')[0] ).scope();
	scope.$root.$apply(function() {
		scope.facebook = desc;
	});	
}


/*eslint-enable */
(function() {
	'use strict';

	angular.module('panorama').controller('PortfolioController', PortfolioController);

	/** @ngInject */
	function PortfolioController($stateParams, $http, $scope, $rootScope) {
		var vm = this;

		//TODO!!! a végpont "null"-t ad vissza!!!
		function isEmpty(obj) {

			if (obj == null || ( typeof obj != "object"))
				return true;

			for (var key in obj) {
				if (Object.prototype.hasOwnProperty.call(obj, key))
					return false;
			}

			return true;
		}

		vm.state = "loading";
		vm.serial = $stateParams.serial;
		$rootScope.panoramaDescriptor.images = null; //hide panorama view;

		if (vm.serial && vm.serial.length) {

			$http.get("api/list.php?serial=" + vm.serial).then(function(response) {

				if (response.data && !isEmpty(response.data)) {
					vm.thumbnails = response.data;
					vm.state = "view";
				} else
					vm.state = "error";
			}, function() {
				vm.state = "error";
			});
			
			vm.name = "";
			$http.get("api/auth.php?serial=" + vm.serial).then(function(response) {

				if (response.data && response.data.facebookname) {
					vm.name = response.data.facebookname;
				} else
					vm.name = "";
					
			}, function() {
				
			});

		} else {
			vm.state = "error";
		}
		
		$scope.$watch(function(scope) {
			return scope.facebook.serial;
		}, function() {
			vm.isOwnGallery = vm.serial && (vm.serial == $scope.facebook.serial);
		});
		
	}

})();

(function() {
	'use strict';

	angular.module('panorama').controller('MainController', MainController);

	/** @ngInject */
	function MainController($stateParams, $log, $http, $window, $scope, $rootScope, $cookies) {
		var vm = this;

		var id = $stateParams.id;

		var initDemo = function(state) {
			$rootScope.panoramaDescriptor.images = ["assets/images/pano2/Left.png", "assets/images/pano2/Right.png", "assets/images/pano2/Bottom.png", "assets/images/pano2/Top.png", "assets/images/pano2/Front.png", "assets/images/pano2/Back.png"];
			vm.state = state;

			$http.get("api/list.php").then(function(response) {
				vm.thumbnails = response.data;
			});
		};

		/*
		 * id: panorama ID (guid)
		 * descriptor: contents of the panorama.json file
		 */

		var init = function(id, descriptor) {

			vm.shareUrl = "http://panorama.archlinexp.com/" + id;
			vm.descriptor = descriptor;
			vm.id = id;

			var imageUrls = [];
			var devideWidth = ($window.innerWidth > 0) ? $window.innerWidth : screen.width;
			var path = devideWidth > 512 ? "uploads/panorama/" + id + "/" : "uploads/panorama/" + id + "/thumb512/";

			if (descriptor && descriptor.images) 
			{
				for (var i = 0; i < descriptor.images.length; i++) imageUrls.push(path + descriptor.images[i]);
			}
			if (imageUrls.length == 6)
			{
				$rootScope.panoramaDescriptor.images = imageUrls;
				vm.state = "view";

				$scope.$watch(function(scope) {
					return scope.facebook.serial;
				}, function() {
					vm.isOwnPanorama = descriptor.serial && (descriptor.serial == $scope.facebook.serial);
					if (vm.isOwnPanorama==false)
					{
						vm.isOwnPanorama=(angular.isDefined($cookies.get("serial")) && $cookies.get("serial")==descriptor.serial ? true : false);
					}
				});
			} 
			else 
			{
				initDemo("error");
			}

			/*
			 * refreshing social plugins
			 */

			/* global FB */
			try {
				FB.XFBML.parse();
			} catch(ex) {
				//
			}

			/* global twttr */
			try {
				twttr.widgets.load();
			} catch(ex) {
				//
			}

			/* global addthis */
			try {
				addthis.init();
				addthis.toolbox('.addthis_native_toolbox');
			} catch(ex) {
				//
			}

		};

		////////////////////////////

		vm.edit = function(field, value) {

			var data = {};
			data[field] = value;
			var originalValue = vm.descriptor[field];

			$log.log("MODIFY:" + field + ": " + originalValue + " -> " + value);

			$http.post("api/modify.php?id=" + id, data ).then(function(response) {
				$log.log(response);
				vm.descriptor[field] = value;
			}, function(response) {
				$log.log(response);
				vm.descriptor[field] = originalValue;
			});

			return true;
		};

		vm.delete = function() {
			$http.get("api/delete.php?id=" + id ).then(function(response) {
				$log.log(response);
				$window.location.href = '/';
			}, function(response) {
				$log.log(response);
			});
		};
		///////////

		if (id && id.length) {
			vm.state = "loading";

			$http.get("api/get.php?id=" + id).then(function(response) {
				//currently uploaded
				init(id, response.data);
			}, function(response) {
				$log.log(response);
				initDemo("error");
			});

		} else {
			initDemo("demo");
		}
	}
})();

(function() {
	'use strict';

	angular.module('panorama').controller('AuthController', AuthController);

	/** @ngInject */
	function AuthController($stateParams, $scope, $http, $log, $rootScope, $location) {
		var str=$location.path();
		var res=str.split("/");
		var vm = this;
		vm.serial = $stateParams.serial;
		vm.invalid=(res[3]=='invalid' ? true : false);
		$rootScope.panoramaDescriptor.images = null; //hide panorama view;		

		var check = function() {
			vm.status = "loading";
			if ($scope.facebook && $scope.facebook.status == "loggedIn") {
	
				$log.log($scope.facebook);
				$log.log('check');
				$http.get("api/auth.php?facebookid=" + $scope.facebook.clientid + "&mark=1").then(function(response) {
					$log.log('check ok');
					$log.log(response);
					if (response.data && response.data.serial == vm.serial) {
						vm.status = "connected";
						$log.log('check connected');
					} else {
						vm.status = "disconnected";
						$log.log('check disconnected');
					}
				}, function(response) {
					$log.log('check error');
					$log.log(response);
					vm.status = "disconnected";
				});
			} else
				vm.status = "disconnected";
		};

		var check2 = function() {
			$http.get("api/auth2.php?serial=" + vm.serial).then(function(response) {
				$log.log('check2 ok');
				vm.strName=response.data.strName;
				vm.cadlogin=( (response.data && response.data.serial == vm.serial) ? "loggedIn" : "loggedOut");
			}, function(response) {
				$log.log('check error');
				$log.log(response);
				vm.cadlogin="loggedOut";
			});
		};

		vm.connect = function() {
			$log.log('connecting ' + $scope.facebook.name);
			vm.status = "loading";
			var url = "api/auth.php" + 
					"?facebookid="  + $scope.facebook.clientid +
					"&serial=" + vm.serial ;
			var data = { "facebookname" : $scope.facebook.name };
			$log.log(url,data);
			$http.post(url,data).then(function(response) {
				$log.log('connecting OK');
				$log.log(response);
				check();
			}, function(response) {
				$log.log('connecting ERROR');
				$log.log(response);
				check();
			});
		};

		vm.disconnect = function() {
			vm.status = "loading";
			$http.get("api/auth.php?facebookid=" + $scope.facebook.clientid + "&disconnect").then(function() {
				check();
			}, function(response) {
				$log.log(response);
				check();
			});
		};

		check();
		check2();

		$scope.$watch(function(scope) {
			return scope.facebook.status;
		}, function() {
			check();
		});
	}
})();

(function() {
	'use strict';

	angular.module('panorama').run(runBlock);

	/** @ngInject */
	function runBlock($log, $rootScope, editableOptions) {

		$rootScope.facebook = {
			status : "loading"
		};
		$rootScope.panoramaDescriptor = {
			images : [],
			direction : 0
		};
		$log.debug('runBlock end');

		//xeditable module
		editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'


	}

})();

(function() {
  'use strict';

  angular
    .module('panorama')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $stateProvider
      .state('home', {
        url: '/:id',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('portfolio', {
        url: '/portfolio/:serial',
        templateUrl: 'app/portfolio/portfolio.html',
        controller: 'PortfolioController',
        controllerAs: 'portfolio'
      })      
      .state('auth', {
        url: '/auth/:serial',
        templateUrl: 'app/auth/auth.html',
        controller: 'AuthController',
        controllerAs: 'auth'
      })
      .state('auth2', {
        url: '/auth/:serial/invalid',
        templateUrl: 'app/auth/auth.html',
        controller: 'AuthController',
        controllerAs: 'auth'
      });

	$locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('panorama')
    .constant('moment', moment);

})();

(function() {
	'use strict';

	angular.module('panorama').config(config);

	/** @ngInject */
	function config($logProvider, $translateProvider) {
		// Enable log
		$logProvider.debugEnabled(true);

		/*
		 * translations
		 */

		var supportedLanguages = ['en', 'hu'];
		var langMap = {
			'en_AU' : 'en',
			'en_CA' : 'en',
			'en_NZ' : 'en',
			'en_PH' : 'en',
			'en_UK' : 'en',
			'en_US' : 'en',
			'hu_HU' : 'hu'
		};
		var fileNameConvention = {
			prefix : '/assets/languages/',
			suffix : '.json'
		};
		$translateProvider
			.useStaticFilesLoader(fileNameConvention)
			.registerAvailableLanguageKeys(supportedLanguages, langMap)
			.determinePreferredLanguage().fallbackLanguage(['en']);
	}

})(); 
angular.module("panorama").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"main-box\"><p>{{ \'PANORAMA_MESS_INTRO\' | translate }}</p></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"main-box\"><img class=\"auth-facebook-icon\" src=\"/assets/images/facebook-icon_56.png\"><h3>{{ \'PANORAMA_MESS_INFO_CONNECT_FACEBOOK\' | translate }}</h3><p>{{ \'PANORAMA_MESS_INFO_LONG_FACEBOOK\' | translate }}.</p></div><div class=\"main-box\"><div ng-show=\"facebook.status==\'loading\' || auth.status == \'loading\'\"><img src=\"/assets/images/bluebar_dots_ani.gif\"></div><div ng-show=\"facebook.status==\'loggedIn\'\"><p>{{ \'PANORAMA_MESS_INFO_LOGIN_FACEBOOK\' | translate }} <b>{{facebook.name}}</b><br>{{ \'PANORAMA_MESS_INFO_SERIAL_ARCHLINE\' | translate }} <b>{{auth.serial}}</b></p><div ng-show=\"auth.status!=\'connected\' && auth.status!=\'conflict\'\"><p>{{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK\' | translate }} <i>{{ \'PANORAMA_MESS_INFO_MY_GALLERY\' | translate }}</i> {{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK2\' | translate }}.</p><p><button ng-click=\"auth.connect()\" class=\"btn btn-primary\">{{ \'PANORAMA_MESS_INFO_CONNECT_FACEBOOK\' | translate }}</button></p></div><div ng-show=\"auth.status==\'connected\'\"><div class=\"alert alert-success\" role=\"alert\"><b>{{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK1\' | translate }}</b> {{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK2\' | translate }} <i>{{ \'PANORAMA_MESS_INFO_MY_GALLERY\' | translate }}</i> {{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK3\' | translate }}</div><p>{{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK_LOGOUT_DESC\' | translate }} <a ng-click=\"auth.disconnect()\" href=\"#\">{{ \'PANORAMA_MESS_INFO_LINK_FACEBOOK_LOGOUT\' | translate }}</a></p></div><div ng-show=\"auth.status==\'conflict\'\"><div class=\"alert alert-danger\" role=\"alert\"><b>{{ \'PANORAMA_MESS_INFO_SERIAL_CONNECTED_OTHER_FACEBOOK\' | translate }}</b></div><p>{{ \'PANORAMA_MESS_INFO_USE_OTHER_FACEBOOK\' | translate }}</p></div></div><p ng-show=\"facebook.status==\'pleaseLoginToApp\'\">{{ \'PANORAMA_MESS_INFO_ENABLE_APP\' | translate }}<br>{{ \'PANORAMA_MESS_INFO_ENABLE_APP3\' | translate }}</p><p ng-show=\"facebook.status==\'pleaseLoginToFacebook\'\">{{ \'PANORAMA_MESS_INFO_ENABLE_APP2\' | translate }}<br>{{ \'PANORAMA_MESS_INFO_ENABLE_APP3\' | translate }}</p><p ng-show=\"facebook.status==\'pleaseLoginToFacebook\' || facebook.status==\'pleaseLoginToApp\'\"><fb:login-button scope=\"public_profile,email\" data-size=\"large\" onlogin=\"checkLoginState();\"></fb:login-button></p></div></div><div class=\"col-md-6\"><div class=\"main-box\"><img class=\"auth-facebook-icon\" src=\"/assets/images/archlinexp_56.png\"><h3>{{ \'PANORAMA_MESS_INFO_CONNECT_ARCHLINE\' | translate }}</h3><p>{{ \'PANORAMA_MESS_INFO_LONG_ARCHLINE\' | translate }}</p></div><div class=\"main-box\"><div ng-show=\"auth.cadlogin==\'loggedOut\'\"><form action=\"//www.archlinexp.com/login-external.php\" method=\"post\"><label>{{ \'PANORAMA_MESS_USERNAME\' | translate }}:</label><input type=\"text\" name=\"username\" id=\"username\"><br><label>{{ \'PANORAMA_MESS_PASSWORD\' | translate }}:</label><input type=\"password\" name=\"password\" id=\"password\"><br><input type=\"submit\" value=\"{{ \'PANORAMA_MESS_LOGIN\' | translate }}\"><br><br><a href=\"{{ \'PANORAMA_MESS_LOSTPASSWORDURL\' | translate }}\" target=\"_blank\">{{ \'PANORAMA_MESS_LOSTPASSWORD\' | translate }}</a> <input type=\"hidden\" name=\"serial\" id=\"serial\" value=\"{{auth.serial}}\" readonly=\"readonly\"></form></div><div ng-show=\"auth.invalid==true\">{{ \'PANORAMA_MESS_INVALID\' | translate }}</div><div ng-show=\"auth.cadlogin==\'loggedIn\'\"><p>{{ \'PANORAMA_MESS_INFO_LOGIN_ARCHLINE\' | translate }}: <b>{{auth.strName}}</b><br>{{ \'PANORAMA_MESS_INFO_SERIAL_ARCHLINE\' | translate }}: <b>{{auth.serial}}</b><br></p><div class=\"alert alert-success\" role=\"alert\"><b>{{ \'PANORAMA_MESS_INFO_LINK_ARCHLINE1\' | translate }}</b> {{ \'PANORAMA_MESS_INFO_LINK_ARCHLINE2\' | translate }} <i>{{ \'PANORAMA_MESS_INFO_MY_GALLERY\' | translate }}</i> {{ \'PANORAMA_MESS_INFO_LINK_ARCHLINE3\' | translate }}</div><form action=\"/api/auth2.php\" method=\"post\"><p>{{ \'PANORAMA_MESS_INFO_LINK_ARCHLINE_LOGOUT_DESC\' | translate }} <input type=\"submit\" value=\"{{ \'PANORAMA_MESS_INFO_LINK_ARCHLINE_LOGOUT\' | translate }}\"><br><input type=\"hidden\" name=\"serial\" id=\"serial\" value=\"{{auth.serial}}\"> <input type=\"hidden\" name=\"disconnect\" id=\"disconnect\" value=\"{{auth.serial}}\"></p></form></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"container main-section\"><div ng-show=\"main.state==\'error\'\" class=\"alert alert-danger\" role=\"alert\">{{ \'PANORAMA_MESS_ERROR_NOTFOUND\' | translate }}.</div><div ng-show=\"main.state==\'loading\'\" class=\"main-box\"><img src=\"/assets/images/bluebar_dots_ani.gif\"></div></div><div class=\"container main-section\"><div ng-show=\"main.state==\'view\'\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"main-box\"><div ng-show=\"main.isOwnPanorama\"><h3 editable-text=\"main.descriptor.project\" onbeforesave=\"main.edit(\'project\',$data)\" e-placeholder=\"{{ \'PANORAMA_LABEL_PROJECT_NAME\' | translate }}\">{{main.descriptor.project || \"[]\" }}</h3><h4 editable-text=\"main.descriptor.view\" onbeforesave=\"main.edit(\'view\',$data)\" e-placeholder=\"{{ \'PANORAMA_LABEL_VIEW_NAME\' | translate }}\">{{main.descriptor.view || \"[]\" }}</h4><p editable-textarea=\"main.descriptor.description\" onbeforesave=\"main.edit(\'description\',$data)\" e-placeholder=\"{{ \'PANORAMA_LABEL_DESCRIPTION\' | translate }}\">{{main.descriptor.description || \"[]\" }}</p></div><div ng-show=\"!main.isOwnPanorama\"><h3>{{main.descriptor.project}}</h3><h4>{{main.descriptor.view}}</h4><p>{{main.descriptor.description}}</p></div><p><small>{{main.descriptor.date*1000 | date:\'yyyy.MM.dd HH:mm:ss\'}}<br>{{main.descriptor.username}}<br>{{main.descriptor.version}}</small></p></div><div class=\"main-box\"><h4>{{ \'SHARE\' | translate }}</h4><p><input style=\"width:100%\" ng-model=\"main.shareUrl\"></p><p><div class=\"addthis_native_toolbox\"></div><sn-addthis-toolbox class=\"addthis_custom_sharing\"></sn-addthis-toolbox></p><p><big>{{ \'PANORAMA_MESS_VOTE\' | translate }}<br>{{ \'PANORAMA_MESS_SHARE\' | translate }}</big></p></div></div><div class=\"col-md-4\" ng-show=\"main.isOwnPanorama\"><div class=\"main-box\"><h4>{{ \'PANORAMA_PUBLISH\' | translate }}</h4><p ng-show=\"main.descriptor.public != \'Y\'\">{{ \'PANORAMA_MESS_PRIVATE\' | translate }}. <button class=\"btn btn-primary\" ng-click=\"main.edit(\'public\',\'Y\')\">{{ \'PANORAMA_MESS_INFO_PUBLIC\' | translate }}</button></p><p ng-show=\"main.descriptor.public == \'Y\'\">{{ \'PANORAMA_MESS_PUBLIC\' | translate }}. <button class=\"btn btn-default\" ng-click=\"main.edit(\'public\',\'N\')\">{{ \'PANORAMA_MESS_INFO_PRIVATE\' | translate }}</button></p><p>{{ \'PANORAMA_MESS_INFO_COMPETITION\' | translate }}</p><p>{{ \'PANORAMA_MESS_PUBLIC_INFO\' | translate }}.</p></div><div class=\"main-box\"><h4>{{ \'PANORAMA_MESS_DELETE\' | translate }}</h4><p ng-show=\"!main.deletevisible\"><button class=\"btn btn-danger\" ng-click=\"main.deletevisible = true\">{{ \'PANORAMA_MESS_DELETE\' | translate }}</button></p><p ng-show=\"main.deletevisible\">{{ \'PANORAMA_MESS_DELETE_INFO\' | translate }}</p><p ng-show=\"main.deletevisible\"><button class=\"btn btn-default\" ng-click=\"main.deletevisible = false\">{{ \'PANORAMA_MESS_CANCEL\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=\"main.delete()\">{{ \'PANORAMA_MESS_DELETE_FINAL\' | translate }}</button></p></div></div></div></div><div ng-show=\"main.state==\'demo\' || main.state==\'error\'\"><div class=\"main-box\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"main-textblock\"><p><big>{{ \'PANORAMA_MESS_INTRO\' | translate }}</big></p><p><big>{{ \'PANORAMA_MESS_COMPETITION\' | translate }}<br>{{ \'PANORAMA_MESS_COMPETITION_DESC\' | translate }} <a href=\"{{ \'PANORAMA_MESS_COMPETITION_LINK\' | translate }}\" target=\"_blank\">{{ \'PANORAMA_MESS_COMPETITION_DESC2\' | translate }}</a></big></p><p><big>{{ \'PANORAMA_MESS_QUESTION\' | translate }}<br><a href=\"{{ \'PANORAMA_MESS_BLOG_LINK\' | translate }}\" target=\"_blank\">{{ \'PANORAMA_MESS_CLICK\' | translate }}</a></big></p></div></div><div class=\"col-md-6\"><div class=\"main-thumbnails\"><thumbnail ng-repeat=\"(key, value) in main.thumbnails\" id=\"{{key}}\" descriptor=\"value\"></thumbnail></div></div></div></div></div></div>");
$templateCache.put("app/portfolio/portfolio.html","<div class=\"container\"><div ng-show=\"portfolio.state==\'error\'\" class=\"alert alert-danger\" role=\"alert\">{{ \'PANORAMA_MESS_ERROR_NOTFOUND_GALLERY\' | translate }}.</div><div ng-show=\"portfolio.state==\'loading\'\" class=\"alert alert-info\"><img src=\"/assets/images/bluebar_dots_ani.gif\"></div><div ng-show=\"portfolio.state==\'view\'\"><div class=\"main-box\"><h3>{{portfolio.name}}</h3><p ng-show=\"portfolio.isOwnGallery\">{{ \'PANORAMA_MESS_INFO_MY_GALLERY\' | translate }}</p></div><div class=\"main-box\"><thumbnail ng-repeat=\"(key, value) in portfolio.thumbnails\" id=\"{{key}}\" descriptor=\"value\"></thumbnail></div></div></div>");
$templateCache.put("app/components/account/account.html","<div ng-show=\"facebook.status==\'loggedIn\'\"><p ng-show=\"facebook.name>\'\'\"><img class=\"facebook-icon\" src=\"/assets/images/facebook-icon_56.png\"> {{facebook.name}}</p><p ng-show=\"facebook.serial != null\"><a href=\"/portfolio/{{facebook.serial}}\" class=\"btn btn-primary\" role=\"button\">{{ \'PANORAMA_MESS_INFO_MY_GALLERY\' | translate }}</a></p></div><div ng-show=\"status==\'loggedIn\' && serial!=null\"><p><a href=\"/portfolio/{{serial}}\" class=\"btn btn-primary\" role=\"button\">{{ \'PANORAMA_MESS_INFO_MY_GALLERY\' | translate }}</a></p></div><div ng-show=\"facebook.status==\'pleaseLoginToApp\'\"><img class=\"facebook-icon\" src=\"/assets/images/facebook-icon_56.png\"> {{ \'PANORAMA_MESS_INFO_LOGIN_TO_ARCHLINE_APP\' | translate }}!</div><div ng-show=\"facebook.status==\'pleaseLoginToFacebook\'\"><img class=\"facebook-icon\" src=\"/assets/images/facebook-icon_56.png\"> {{ \'PANORAMA_MESS_INFO_LOGIN_TO_FACEBOOK_AND_ARCHLINE_APP\' | translate }}!</div><div ng-show=\"facebook.status==\'pleaseLoginToFacebook\' || facebook.status==\'pleaseLoginToApp\'\"><fb:login-button scope=\"public_profile,email\" onlogin=\"checkLoginState();\"></fb:login-button></div>");
$templateCache.put("app/components/languageSwitch/languageSwitch.html","<span ng-repeat=\"language in supportedLanguages\">&nbsp; <b ng-show=\"language==currentLanguage\">{{\"FOOTER_LANGUAGE_\" + language | translate}}</b> <a ng-show=\"language!=currentLanguage\" href=\"#\" ng-click=\"changeLanguage(\'{{language}}\')\">{{\"FOOTER_LANGUAGE_\" + language | translate}}</a> &nbsp;</span>");
$templateCache.put("app/components/thumbnail/thumbnail.html","<div class=\"panorama-thumbnail\"><a href=\"/{{id}}\"><img src=\"{{imageUrl}}\"><p>{{descriptor.project}}<br><small>{{descriptor.view}}</small></p></a></div>");}]);